<p>Using the Climber App, you may retry the failed payment or enter a new payment method for the membership.</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
